var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "chairman" },
    [
      _c("Title", {
        attrs: { zhTitle: _vm.pageData.name, enTitle: _vm.pageData.name },
      }),
      _c("div", { staticClass: "content" }, [
        _vm.language === "zh"
          ? _c("div", [
              _c("div", { staticClass: "describe" }, [
                _c("div", {
                  staticClass: "discribe1",
                  domProps: { textContent: _vm._s(_vm.jsonData.wishes) },
                }),
                _c("div", { staticClass: "bottom" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.jsonData.inscribe) +
                      "\n            "
                  ),
                  _vm.jsonData.likeness
                    ? _c("img", { attrs: { src: _vm.jsonData.likeness } })
                    : _vm._e(),
                ]),
              ]),
            ])
          : _vm.language === "en"
          ? _c("div", [
              _c("div", { staticClass: "describe" }, [
                _c("div", {
                  staticClass: "discribe1",
                  domProps: { textContent: _vm._s(_vm.jsonData.wishesEng) },
                }),
                _c("div", { staticClass: "bottom" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.jsonData.inscribeEng) +
                      "\n            "
                  ),
                  _vm.jsonData.likeness
                    ? _c("img", { attrs: { src: _vm.jsonData.likeness } })
                    : _vm._e(),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }